const getShutterStockFilterSchema = (i18n) => {
  const filterSchema = {
    properties: {
      people_model_released: {
        name: 'People Model Released',
        filterable: true,
        title: i18n.getString('ShutterStock_Filter_People_Model_Released'),
        type: 'string',
        property: 'people_model_released',
        enum: [
          'true',
          'false',
        ],
        localized: {
          true: i18n.getString('ShutterStock_Filter_People_Model_Released_True'),
          false: i18n.getString('ShutterStock_Filter_People_Model_Released_False'),
        },
        operatorDisplayNameMap: {
          eq: i18n.getString('ShutterStock_Filter_Operator_Eq'),
        },
        operators: [
          'eq',
        ],
        chooseType: 'radio',
      },
      people_ethnicity: {
        name: 'People Ethnicity',
        filterable: true,
        title: i18n.getString('ShutterStock_Filter_People_Ethnicity'),
        type: 'string',
        property: 'people_ethnicity',
        enum: [
          'african',
          'african_american',
          'black',
          'brazilian',
          'chinese',
          'caucasian',
          'east_asian',
          'hispanic',
          'japanese',
          'middle_eastern',
          'native_american',
          'pacific_islander',
          'south_asian',
          'southeast_asian',
          'other',
        ],
        localized: {
          african: i18n.getString('ShutterStock_Filter_People_Ethnicity_African'),
          african_american: i18n.getString('ShutterStock_Filter_People_Ethnicity_African_American'),
          black: i18n.getString('ShutterStock_Filter_People_Ethnicity_Black'),
          brazilian: i18n.getString('ShutterStock_Filter_People_Ethnicity_Brazilian'),
          chinese: i18n.getString('ShutterStock_Filter_People_Ethnicity_Chinese'),
          caucasian: i18n.getString('ShutterStock_Filter_People_Ethnicity_Caucasian'),
          east_asian: i18n.getString('ShutterStock_Filter_People_Ethnicity_East_Asian'),
          hispanic: i18n.getString('ShutterStock_Filter_People_Ethnicity_Hispanic'),
          japanese: i18n.getString('ShutterStock_Filter_People_Ethnicity_Japanese'),
          middle_eastern: i18n.getString('ShutterStock_Filter_People_Ethnicity_Middle_Eastern'),
          native_american: i18n.getString('ShutterStock_Filter_People_Ethnicity_Native_American'),
          pacific_islander: i18n.getString('ShutterStock_Filter_People_Ethnicity_Pacific_Islander'),
          south_asian: i18n.getString('ShutterStock_Filter_People_Ethnicity_South_Asian'),
          southeast_asian: i18n.getString('ShutterStock_Filter_People_Ethnicity_Southeast_Asian'),
          other: i18n.getString('ShutterStock_Filter_People_Ethnicity_Other'),
        },
        operatorDisplayNameMap: {
          eq: i18n.getString('ShutterStock_Filter_Operator_Eq'),
        },
        operators: [
          'eq',
        ],
        chooseType: 'checkbox',
      },
      people_gender: {
        name: 'People Gender',
        filterable: true,
        title: i18n.getString('ShutterStock_Filter_People_Gender'),
        type: 'string',
        property: 'people_gender',
        enum: [
          'male',
          'female',
          'both',
        ],
        localized: {
          male: i18n.getString('ShutterStock_Filter_People_Male'),
          female: i18n.getString('ShutterStock_Filter_People_Female'),
          both: i18n.getString('ShutterStock_Filter_People_Both'),
        },
        operatorDisplayNameMap: {
          eq: i18n.getString('ShutterStock_Filter_Operator_Eq'),
        },
        operators: [
          'eq',
        ],
        chooseType: 'radio',
      },
      people_age: {
        name: 'People Age',
        filterable: true,
        title: i18n.getString('ShutterStock_Filter_People_Age'),
        type: 'string',
        property: 'people_model_age',
        enum: [
          'infants',
          'children',
          'teenagers',
          '20s',
          '30s',
          '40s',
          '50s',
          '60s',
          'older',
        ],
        localized: {
          infants: i18n.getString('ShutterStock_Filter_People_Age_Infants'),
          children: i18n.getString('ShutterStock_Filter_People_Age_Children'),
          teenagers: i18n.getString('ShutterStock_Filter_People_Age_Teenagers'),
          '20s': i18n.getString('ShutterStock_Filter_People_Age_20s'),
          '30s': i18n.getString('ShutterStock_Filter_People_Age_30s'),
          '40s': i18n.getString('ShutterStock_Filter_People_Age_40s'),
          '50s': i18n.getString('ShutterStock_Filter_People_Age_50s'),
          '60s': i18n.getString('ShutterStock_Filter_People_Age_60s'),
          older: i18n.getString('ShutterStock_Filter_People_Age_Older'),
        },
        operatorDisplayNameMap: {
          eq: i18n.getString('ShutterStock_Filter_Operator_Eq'),
        },
        operators: [
          'eq',
        ],
        chooseType: 'radio',
      },
      people_number: {
        name: 'People Number',
        filterable: true,
        title: i18n.getString('ShutterStock_Filter_People_Number'),
        type: 'string',
        property: 'people_number',
        enum: [
          '1',
          '2',
          '3',
          '4',
        ],
        localized: {
          1: '1',
          2: '2',
          3: '3',
          4: '4+',
        },
        operatorDisplayNameMap: {
          eq: i18n.getString('ShutterStock_Filter_Operator_Eq'),
        },
        operators: [
          'eq',
        ],
        chooseType: 'radio',
      },
    },
    // work-around to have the noDuplicateValidation. Will remove once predicate supports it
    name: 'ShutterStockPeopleFilterSchema',
    type: 'object',
  };

  return filterSchema;
};

export { getShutterStockFilterSchema };
